<template>
    <div class="flex flex-col items-center">
        <p class="title">{{ text }}</p>
        <button
            class="btn btn-primary"
            @click="$router.push({ name: 'applications' })"
        >
            Go back
        </button>
    </div>
</template>

<script>
import { MUTATIONS } from '../../store/wizard/types';

export default {
    data() {
        return {
            text: ''
        }
    },

    created() {
        this.text = this.$route.query.hasOwnProperty('contact') ?
            'Thank you. An engineer will contact you shortly.' :
            'Your email has been sent correctly.';

        this.$store.commit(MUTATIONS.RESET_CONSULT);
    }
};
</script>
